function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "background-mask-mobile",
  clipPathUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0.009 C1,0.004,0.995,0,0.988,0 L0.011,0.032 C0.005,0.032,0,0.036,0,0.04 L0.042,0.933 C0.042,0.937,0.046,0.94,0.052,0.941 L0.925,1 C0.932,1,0.937,0.997,0.938,0.993 L1,0.009"
}));

var SvgBackgroundMaskMobile = function SvgBackgroundMaskMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackgroundMaskMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background-mask-mobile.d3b3aa0b.svg";
export { ForwardRef as ReactComponent };